import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const getPrices = async (pageNo = 1, pageSize = 500, param) => {
  let params = {};
  if (param) params = { pageNo, pageSize, ...param };
  else params = { pageNo, pageSize };
  return await axios.get(`${baseURL}/course-prices`, { params });
};

export const addPricingOption = async (params) => {
  return await axios.post(`${baseURL}/course-price`, params);
};